import script from "./pc-module-survey-1.vue?vue&type=script&lang=ts&setup=true"
export * from "./pc-module-survey-1.vue?vue&type=script&lang=ts&setup=true"

import "./pc-module-survey-1.vue?vue&type=style&index=0&id=e8fb2be6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8fb2be6"]])

export default __exports__